import React from "react";
import clsx from "clsx";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { DateTime } from "luxon";
import { FormattedMessage, FormattedDate } from "react-intl";

import ellipseText from "./utils/ellipseText";
import AuthorShortDisplay from "./AuthorShortDisplay";

import styles from "./ArticleLaunchCard.module.css";

const MAX_SUBTITLE_LENGTH = 200;

export default function ArticleLaunchCard({
  to,
  title,
  subtitle,
  className,
  featuredImage,
  featured,
  authors,
  date,
  minutesRead,
  langKey,
  ...rest
}) {
  const jsDate = DateTime.fromFormat(date, "yyyy-MM-dd").toJSDate();

  return (
    <Link
      to={to}
      className={clsx(styles.card, featured && styles.cardFeatured, className)}
      {...rest}
    >
      {featuredImage && (
        <Img
          fluid={featuredImage.childImageSharp.fluid}
          className={clsx(
            styles.imageWrapper,
            featured && styles.imageFeatured,
          )}
        />
      )}

      <div
        className={clsx(styles.cardContent, featured && styles.contentFeatured)}
      >
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.articleInfo}>
          {date && (
            <FormattedDate
              value={jsDate}
              year="numeric"
              month="long"
              day="numeric"
            />
          )}{" "}
          —{" "}
          <FormattedMessage
            id="time-to-read-in-minutes"
            values={{ minutes: minutesRead }}
          />
        </div>
        <p className={styles.subtitle}>
          {subtitle && ellipseText(subtitle, MAX_SUBTITLE_LENGTH)}
        </p>

        {authors.map((author) => (
          <AuthorShortDisplay
            key={author.id}
            id={author.id}
            className={styles.author}
            image={author.image}
            fullName={author.fullName}
            role={author.role}
          />
        ))}
      </div>
    </Link>
  );
}
